// src/components/NotificationList.jsx

import React from "react";
import { EllipsisHorizontalIcon } from "@heroicons/react/24/solid";

// --- DATA DUMMY ---
// Data ini ditempatkan di sini untuk kemudahan demonstrasi.
// const masterNotificationsData = [
//   {
//     id: 1,
//     botName: "Xenoarc-Simple Bot",
//     icon1:
//       "https://cdn.builder.io/api/v1/image/assets/TEMP/4da79bc120b2adf00fed6f6159aed7bb8a4f35d4a1f8a109f1ad6b71d75cb6f0?placeholderIfAbsent=true",
//     icon2:
//       "https://seeklogo.com/images/B/binance-logo-04F5342934-seeklogo.com.png",
//     timestamp: "27/06/2025 10:19",
//     title: "Limit order filled",
//     description: "Sell 0.001010 BTC at 100,000.00 USDT",
//     isRead: false,
//     type: "system",
//   },
//   {
//     id: 2,
//     botName: "DCA Bot",
//     icon1:
//       "https://cdn.builder.io/api/v1/image/assets/TEMP/4da79bc120b2adf00fed6f6159aed7bb8a4f35d4a1f8a109f1ad6b71d75cb6f0?placeholderIfAbsent=true",
//     icon2: "https://seeklogo.com/images/O/okx-logo-E5OKEX-A52874.svg",
//     timestamp: "25/06/2025 12:30",
//     title: "Market Price Above",
//     description: "Market price is above BOT's maximum price or minimum price",
//     isRead: true,
//     type: "system",
//   },
//   {
//     id: 3,
//     timestamp: "27/06/2025 08:00",
//     title: "System Maintenance Scheduled",
//     description: "We will be undergoing scheduled maintenance on Dec 28, 2024.",
//     isRead: false,
//     type: "announcement",
//   },
//   {
//     id: 4,
//     timestamp: "20/06/2025 18:30",
//     title: "New Feature: Trailing Stop Loss",
//     description:
//       "Trailing Stop Loss is now available for all spot trading bots.",
//     isRead: true,
//     type: "announcement",
//   },
// ];

// // --- KOMPONEN UNTUK SATU ITEM NOTIFIKASI ---
// const NotificationItem = ({ notification, isLastItem }) => {
//   // Tampilan untuk "announcement"
//   if (notification.type === "announcement") {
//     return (
//       <div
//         className={`relative p-4 transition-colors ${
//           !notification.isRead ? "bg-cyan-50/40" : "bg-white"
//         } ${!isLastItem ? "border-b border-gray-200" : ""}`}
//       >
//         <div className="flex justify-between items-start">
//           <div className="flex items-start gap-3">
//             <div className="flex flex-col">
//               <div className="flex items-center gap-2">
//                 <div className="border border-[#DDE1E6] p-1 rounded-full">
//                   <img
//                     class="bot__icon"
//                     src="/images/icons/icon_megaphone.svg"
//                     className="w-4 h-4 mr-1"
//                   />
//                 </div>
//                 <span className="text-sm font-semibold text-gray-400">
//                   Xenorush
//                 </span>
//                 <span className="text-xs text-gray-400">|</span>
//                 <span className="text-xs text-gray-400">
//                   {notification.timestamp}
//                 </span>
//               </div>
//               <div className="mt-0.5 flex flex-col gap-1">
//                 <span className="font-bold text-sm text-gray-800">
//                   {notification.title}
//                 </span>
//                 <span className="text-sm text-gray-600">
//                   {notification.description}
//                 </span>
//               </div>
//             </div>
//           </div>
//           {notification.isRead ? (
//             <div></div>
//           ) : (
//             <div className="w-3 h-3 rounded-full bg-[#007A78]"></div>
//           )}
//         </div>
//       </div>
//     );
//   }

//   // Tampilan default untuk "system"
//   return (
//     <div
//       className={`flex items-center justify-between gap-4 p-4 ${
//         !notification.isRead ? "bg-cyan-50/40" : "bg-white"
//       } ${!isLastItem ? "border-b border-gray-200" : ""}`}
//     >
//       <div className="flex items-start gap-3 flex-1">
//         <div className="flex-1 flex flex-col gap-2">
//           <div className="flex items-center gap-2 text-sm">
//             <div className="flex items-center -space-x-2">
//               <img
//                 src={notification.icon1}
//                 alt="bot icon"
//                 className="w-5 h-5 rounded-full bg-white border border-gray-200"
//               />
//               <img
//                 src={notification.icon2}
//                 alt="exchange icon"
//                 className="w-5 h-5 rounded-full bg-white border border-gray-200"
//               />
//             </div>
//             <span className="text-sm font-semibold text-gray-400">
//               {notification.botName}
//             </span>
//             <span className="text-gray-400">|</span>
//             <span className="text-gray-400">{notification.timestamp}</span>
//           </div>
//           <div className="mt-0.5 flex flex-col gap-1">
//             <span className="font-bold text-sm text-gray-800">
//               {notification.title}
//             </span>
//             <span className="text-sm text-gray-600">
//               {notification.description}
//             </span>
//           </div>
//         </div>
//       </div>
//       {notification.isRead ? (
//         <div></div>
//       ) : (
//         <div className="w-3 h-3 rounded-full bg-[#007A78]"></div>
//       )}
//     </div>
//   );
// };

// // --- KOMPONEN UTAMA NOTIFICATION LIST ---
// // Menerima 'notifications' sebagai prop untuk ditampilkan
// export const NotificationList = ({ notifications = [] }) => {
//   if (!notifications || notifications.length === 0) {
//     return (
//       <div className="bg-white rounded-xl mt-6 h-[10rem] flex items-center p-3 text-sm justify-center text-center text-gray-400">
//         No notifications found.
//       </div>
//     );
//   }

//   return (
//     <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
//       {notifications.map((notification, index) => (
//         <NotificationItem
//           key={notification.id}
//           notification={notification}
//           isLastItem={index === notifications.length - 1}
//         />
//       ))}
//     </div>
//   );
// };

// export const NotificationListExample = () => {
//   const systemNotifications = masterNotificationsData.filter(
//     (n) => n.type === "system",
//   );
//   const announcementNotifications = masterNotificationsData.filter(
//     (n) => n.type === "announcement",
//   );

//   return (
//     <div className="p-8 bg-gray-100 font-sans">
//       <h1 className="text-xl font-bold mb-4">Contoh Tampilan Notifikasi</h1>

//       <h2 className="text-lg font-semibold mt-8 mb-2">Notifikasi Sistem</h2>
//       <NotificationList notifications={systemNotifications} />

//       <h2 className="text-lg font-semibold mt-8 mb-2">Notifikasi Pengumuman</h2>
//       <NotificationList notifications={announcementNotifications} />
//     </div>
//   );
// };

// export default NotificationListExample;

// YANG LAMA

import NotificationGroupSkeleton from "./skeletons/NotificationGroupSkeleton";
import { getAssetName, normalizePair } from "../../utils";

// Data mentah
const rawNotifications = [
  {
    date: "26 December 2024",
    notifications: [
      {
        pair: "BTC/USDT",
        bot: "USAGI BOT",
        exchange: "Binance",
        message: "Limit order filled - sell 0.001010 BTC at 100,000.00 USDT",
        timestamp: "26/12/2024 10:19",
      },
      {
        pair: "BTC/USDT",
        bot: "USAGI BOT",
        exchange: "Binance",
        message: "Limit order filled - sell 0.001010 BTC at 100,000.00 USDT",
        timestamp: "26/12/2024 10:19",
      },
      {
        pair: "BTC/USDT",
        bot: "USAGI BOT",
        exchange: "Binance",
        message: "Limit order filled - sell 0.001010 BTC at 100,000.00 USDT",
        timestamp: "26/12/2024 10:19",
      },
    ],
  },
  {
    date: "25 December 2024",
    notifications: [
      {
        pair: "ETH/USDT",
        exchange: "OKX",
        message: "Market order filled - sell 1.5 ETH at 4,135.84 USDT",
        timestamp: "26/12/2024 10:19",
      },
      {
        pair: "ETH/USDT",
        exchange: "OKX",
        message: "Market order filled - sell 1.5 ETH at 4,135.84 USDT",
        timestamp: "26/12/2024 10:19",
      },
      {
        pair: "ETH/USDT",
        exchange: "OKX",
        message: "Market order filled - sell 1.5 ETH at 4,135.84 USDT",
        timestamp: "26/12/2024 10:19",
      },
      {
        pair: "ETH/USDT",
        exchange: "OKX",
        message: "Market order filled - sell 1.5 ETH at 4,135.84 USDT",
        timestamp: "26/12/2024 10:19",
      },
    ],
  },
  {
    date: "25 December 2024",
    notifications: [
      {
        pair: "ETH/USDT",
        exchange: "OKX",
        message: "Market order filled - sell 1.5 ETH at 4,135.84 USDT",
        timestamp: "26/12/2024 10:19",
      },
    ],
  },
];

// Fungsi untuk menggabungkan berdasarkan tanggal
const groupNotificationsByDate = (notifications) => {
  const grouped = {};

  notifications.forEach(({ date, notifications }) => {
    if (!grouped[date]) {
      grouped[date] = [];
    }
    grouped[date] = grouped[date].concat(notifications);
  });

  // Ubah hasil menjadi array
  return Object.entries(grouped).map(([date, notifications]) => ({
    date,
    notifications,
  }));
};

export const NotificationList = ({ notifications, loading }) => {
  return (
    <>
      {loading ? (
        groupNotificationsByDate(rawNotifications).map((group, index) => (
          <NotificationGroupSkeleton
            key={index}
            date={group.date}
            notifications={group.notifications}
          />
        ))
      ) : !!notifications?.length ? (
        notifications.map((group, index) => (
          <NotificationGroup
            key={index}
            date={group.date}
            notifications={group.notifications}
          />
        ))
      ) : (
        <div className="bg-white rounded-xl mt-6 h-[10rem] flex items-center  p-3 text-sm justify-center text-center text-gray-400">
          No data found.
        </div>
      )}
    </>
  );
};

export default NotificationList;

const NotificationGroup = ({ date, notifications }) => {
  return (
    <>
      <div className="text-base font-semibold text-black mb-2 mt-6">{date}</div>
      <div className="bg-gray-100 rounded-xl">
        <div className="bg-white rounded-xl overflow-hidden border border-gray-200">
          {notifications.map((notification, index) => (
            <div
              key={index}
              className={`p-4 flex flex-col md:flex-row md:items-center justify-between space-y-4 md:space-y-0 md:space-x-12 ${
                index !== notifications.length - 1
                  ? "border-b border-gray-200"
                  : ""
              }`}
            >
              {/* Pair + Bot */}
              <div className="flex flex-col w-full max-w-[9.5rem]">
                <span className="text-sm font-medium text-gray-800">
                  {normalizePair(notification?.pair) || "Xenorize"}
                </span>
                <span className="bg-gray-200 text-xs px-2 py-0.5 rounded-full font-semibold w-fit mt-1">
                  {notification?.bot || "XENORIZE SYSTEM"}
                </span>
              </div>

              {/* Exchange */}
              <div className="flex items-center space-x-2 min-w-[100px]">
                {/* <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/4da79bc120b2adf00fed6f6159aed7bb8a4f35d4a1f8a109f1ad6b71d75cb6f0?placeholderIfAbsent=true&apiKey=59c0fa6b8aa4495494df54f00a70cb5c"
                  alt=""
                  className="w-4 h-4"
                /> */}
                <span className="text-sm text-gray-700 font-medium">
                  {!!notification?.exchange
                    ? notification?.exchange !== "Unknown"
                      ? notification?.exchange
                      : "General"
                    : "-"}
                </span>
              </div>

              {/* Message */}
              <div className="text-sm text-gray-800 flex-1">
                {notification?.message || "-"}
              </div>

              {/* Timestamp */}
              <div className="text-sm text-gray-500 whitespace-nowrap min-w-[100px] text-right">
                {notification?.timestamp || "-"}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
